import { useState } from 'react'

import {
  Checkbox,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core'
import { Add } from '@material-ui/icons'
import Search from 'Components/UI/Atoms/Search'

import Extra from './Extra'

const Step2 = (props) => {
  const { initValues, setInitValues } = props
  const [valueSearch, setValueSearch] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [count, setCount] = useState(initValues.products.filter((p) => p.checked).length)

  const filteredProducts = initValues.products.filter((item) =>
    item.producto.toLowerCase().includes(valueSearch.toLowerCase())
  )

  const handleOpenModal = (item) => {
    setSelectedItem(item)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setSelectedItem(null)
  }

  const onChangeBrand = (e) => {
    setValueSearch(e.target.value)
  }

  const setNew = (array) => {
    setInitValues({ ...initValues, products: array })
  }

  const handleChange = (e, index, id) => {
    const checked = e.target.checked
    const clonedData = [...initValues.products]

    const newProducts = clonedData.map((prod) => {
      if (prod.id === id) {
        if (checked) {
          return {
            ...prod,
            checked: true,
            items: prod.items.map((item) => {
              const originalItem = prod.itemsOriginal?.find(
                (orig) => orig.stock_id === item.stock_id
              )
              return {
                ...item,
                checked: originalItem ? originalItem.checked : item.checked,
              }
            }),
          }
        } else {
          const originalItems = prod.itemsOriginal || []

          return {
            ...prod,
            checked: false,
            items: originalItems
              .filter((item) => item.stock_id && item.estado !== undefined && item.estado !== null)
              .map((item) => ({
                ...item,
                checked: false,
              })),
          }
        }
      }
      return prod
    })

    setNew(newProducts)

    const count = newProducts.filter((p) => p.checked).length
    setCount(count)
  }

  function compare(item) {
    if (item.items && item.items.length > 0) {
      const hasColocado = item.items.some(
        (i) => i.estado === 'Colocado' || i.estado === undefined || i.estado === null
      )
      if (!hasColocado) return true
    }

    if (!item.grupo_colocado) return false

    return initValues.products
      .filter((e) => e.grupo_colocado === item.grupo_colocado)
      .some((e) => e.checked === true && e.producto !== item.producto)
  }

  return (
    <>
      <div
        style={{
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          zIndex: 10,
          paddingBottom: '8px',
        }}
      >
        <Search placeholder="Buscar" onChange={onChangeBrand} value={valueSearch} />
      </div>

      <div style={{ color: '#6f6f6fee', display: 'flex', justifyContent: 'center' }}>
        <p>Cantidad de productos seleccionados: {count}</p>
      </div>

      <Grid container>
        <Table style={{ tableLayout: 'fixed' }} size="small">
          <TableBody>
            {filteredProducts.map((item, index) => (
              <TableRow>
                <TableCell style={{ width: '10%' }}>
                  <Checkbox
                    checked={item.checked || false}
                    onChange={(e) => handleChange(e, index, item.id)}
                    disabled={compare(item)}
                  />
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    width: '20%',
                    color: item.items.length === 0 && item.checked === true ? '#b52d2d' : '#000',
                  }}
                >
                  {item.producto}
                </TableCell>
                <TableCell style={{ width: '10%' }}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleOpenModal(item)
                    }}
                    disabled={
                      !item.checked ||
                      (item.items &&
                        item.items.length > 0 &&
                        !item.items.some(
                          (i) =>
                            i.estado === 'Colocado' || i.estado === undefined || i.estado === null
                        ))
                    }
                  >
                    <Add />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>

      {openModal && (
        <Extra
          open={openModal}
          handleclose={handleCloseModal}
          setInitValues={setInitValues}
          initValues={initValues}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      )}
    </>
  )
}

export default Step2
